import { Button, Modal } from "react-bootstrap";

const SimpleModal = ({ title, children, handleClose, show, size = "sm" }) => {
  return (
    <Modal className="fade lao" show={show} onHide={handleClose} size={size}>
      <Modal.Header>
        <Modal.Title>{title}</Modal.Title>
        <Button className="btn-close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default SimpleModal;
